// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V8Lu+","footer__social":"Footer_footer__social__6kjG4"};